import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum ToomPurchaseOrderProductionLineItemKeys {
  itemType = 'itemType',
  number = 'number',
  description = 'description',
  qtyOrdered = 'qtyOrdered',
  uom = 'uom',
  unitCost = 'unitCost',
  totalCost = 'totalCost',
}

const toomPurchaseOrderProductionAddressSchema = yup.object().shape({
  companyName: yup.string().nullable().optional(),
  addressLine1: yup.string().nullable().optional(),
  addressLine2: yup.string().nullable().optional(),
  city: yup.string().nullable().optional(),
  state: yup.string().nullable().optional(),
  zipCode: yup.string().nullable().optional(),
  country: yup.string().nullable().optional(),
  contactName: yup.string().nullable().optional(),
  phoneNumber: yup.string().nullable().optional(),
  emailAddress: yup.string().nullable().optional(),
})

const toomPurchaseOrderProductionLineItemSchema = yup.object().shape({
  [ToomPurchaseOrderProductionLineItemKeys.itemType]: yup.string().nullable().optional(),
  [ToomPurchaseOrderProductionLineItemKeys.number]: yup.string().nullable().optional(),
  [ToomPurchaseOrderProductionLineItemKeys.description]: yup.string().nullable().optional(),
  [ToomPurchaseOrderProductionLineItemKeys.qtyOrdered]: yup.string().nullable().optional(),
  [ToomPurchaseOrderProductionLineItemKeys.uom]: yup.string().nullable().optional(),
  [ToomPurchaseOrderProductionLineItemKeys.unitCost]: yup.string().nullable().optional(),
  // totalCost is auto-computed at render time (qtyOrdered × unitCost)
})

export const toomPurchaseOrderProductionFileDataSchema = yup.object().shape({
  poNumber: yup.string().nullable().optional(),
  startDate: yup.string().nullable().optional(),
  dueDate: yup.string().nullable().optional(),
  vendor: toomPurchaseOrderProductionAddressSchema,
  shipTo: toomPurchaseOrderProductionAddressSchema,
  buyer: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  fobPoint: yup.string().nullable().optional(),
  shippingTerms: yup.string().nullable().optional(),
  shipVia: yup.string().nullable().optional(),
  dateScheduled: yup.string().nullable().optional(),
  poNotes: yup.string().nullable().optional(),
  items: yup.array().of(toomPurchaseOrderProductionLineItemSchema).required(),
  instructions: yup.string().nullable().optional(),
})

export type ToomPurchaseOrderProductionFileData = yup.InferType<
  typeof toomPurchaseOrderProductionFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<ToomPurchaseOrderProductionFileData>

export const toomPurchaseOrderProductionFileMappings: RequiredFileData = {
  poNumber: '5ce2948f-7ff0-4710-801b-61eb585a4e0a',
  startDate: '5378a6b5-2fd9-4988-a918-3bc7dd1f3c58',
  dueDate: 'bc5774c9-afc9-4e53-9ac4-7246c259ad5c',
  vendor: {
    companyName: '70c193db-279a-4ce9-b060-9696e01b612f',
    addressLine1: 'd3ba15c8-fc47-48f0-ac66-113fed19f19b',
    addressLine2: '22d0e804-8a16-4a61-8716-126016166d7a',
    city: '1f0c9152-9236-4532-ae81-b0b0e833e8a1',
    state: 'bc998ac5-ec2e-4410-805c-c6aafbc4042e',
    zipCode: 'd7256502-202c-4856-bbd1-c8c0160cfb4d',
    country: '3383f4a2-a056-415c-bc2c-36af5c0e3cae',
    contactName: 'fc817986-cb99-4e37-86d0-3ce3cb45289a',
    phoneNumber: '4bbbc5ee-f03c-4d76-b178-d24f07a2c083',
    emailAddress: '02283e41-ecb5-41ea-8162-caea7c57beca',
  },
  shipTo: {
    companyName: '53a671e7-8622-4625-82f1-cb82c0d47a53',
    addressLine1: '23eaf92e-ee3d-4b12-8925-88339ff6811c',
    addressLine2: '6e27c5d0-9234-40e0-928e-c293f9860899',
    city: 'd4e8c44f-b18f-4610-a02f-0b3c6f13f59c',
    state: '3420e9df-3148-4d8d-884b-879a9e269fa3',
    zipCode: '6ce8e431-4b52-4b50-ab3e-f26e05745675',
    country: '1ff79a9f-c1dc-4806-8c88-b243ab5fb814',
    contactName: '4036db53-8ef0-440d-a18b-73a184625797',
    phoneNumber: '65b245bd-f264-4984-a5a4-375b7acc043a',
    emailAddress: '8593ad18-cf84-4959-bd60-7603b4e6c600',
  },
  buyer: '476ce5ad-0ea8-47e6-ae18-87d97fd7d1b3',
  paymentTerms: 'bfbfc627-0617-4f92-a830-7a67413f6190',
  fobPoint: '333c2ecb-b079-40a1-870e-3cb0883f524b',
  shippingTerms: 'b6737e24-fa19-4f32-8e8a-f4bfe582c94e',
  shipVia: 'c4c7011c-f7c3-4bc1-895d-f4330c30e0d2',
  dateScheduled: 'f0d01c20-70ae-423f-952d-a53b1da12969',
  poNotes: 'c39fa01a-7095-4b7a-9294-a4d262dcdb20',
  items: [
    {
      itemType: '76feced4-e04d-426f-a5a7-d64d2224b4cb',
      number: 'f76678a5-c5ed-428e-9125-9adfac998543',
      description: '32943a9a-df37-4b29-9f07-be80713f9c47',
      qtyOrdered: '7ed76bc2-9838-40f7-a7a1-613c36442d47',
      uom: '7327fe29-289f-4524-8961-70aa5919abc0',
      unitCost: 'f1a09edf-fc74-4432-98a4-d88f29173656',
    },
  ],
  instructions: '9afddf34-0962-437c-b1f6-bc28e7c6a763',
}

export const mockToomPurchaseOrderProductionData: RequiredFileData = {
  poNumber: 'PO-11',
  startDate: '08/12/2026',
  dueDate: '08/18/2026',
  vendor: {
    companyName: 'Columbus Oils - Des Plaines',
    addressLine1: '30 East Oakton Street',
    addressLine2: '',
    city: 'Des Plaines',
    state: 'IL',
    zipCode: '60018',
    country: 'United States',
    contactName: 'Marco Favia',
    phoneNumber: '847-257-8920',
    emailAddress: 'mfavia@cvoils.com',
  },
  shipTo: {
    companyName: 'The Fresh Factory - Production',
    addressLine1: '485 Crossroads Pkwy Dock A',
    addressLine2: '',
    city: 'Bolingbrook',
    state: 'IL',
    zipCode: '60440',
    country: 'United States',
    contactName: 'Shipping',
    phoneNumber: '708-254-5906',
    emailAddress: 'orders@thefreshfactory.co',
  },
  buyer: 'TOOM Purchasing',
  paymentTerms: 'Net 30',
  fobPoint: 'Origin',
  shippingTerms: 'Prepaid',
  shipVia: 'TransLoop Logistics',
  dateScheduled: '07/31/2026',
  poNotes: 'Supplier must reference PO-11 on all shipping and invoice documentation.',
  items: [
    {
      itemType: 'Raw Material',
      number: '50012',
      description: 'Non-GMO Expeller Pressed Canola Oil',
      qtyOrdered: '42000',
      uom: 'Pound',
      unitCost: '0.95',
    },
  ],
  instructions:
    'Supplier should reference the PO number on invoices and delivery documentation. Contact TOOM before changing quantity, price, or delivery timing.',
}
